// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD1y904HcKMNeubLk24IMAzw79lPV8bxOE",
  authDomain: "premmilan-b6c87.firebaseapp.com",
  projectId: "premmilan-b6c87",
  storageBucket: "premmilan-b6c87.appspot.com",
  messagingSenderId: "731984078318",
  appId: "1:731984078318:web:82d4f9d31c282c3d7d1aff"
};

// Initialize Firebase
initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore();
